import { render, staticRenderFns } from "./modelData.vue?vue&type=template&id=47cad7a6&scoped=true&"
import script from "./modelData.vue?vue&type=script&lang=js&"
export * from "./modelData.vue?vue&type=script&lang=js&"
import style0 from "./modelData.vue?vue&type=style&index=0&id=47cad7a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cad7a6",
  null
  
)

export default component.exports